import { axiosInstance } from 'services';
import { AxiosResponse } from 'axios';

import { IFeedProposalDataResponse } from 'types/interfaces';
import { feedMock } from 'mockedData/feed.page';

export const FeedProposalApi = {
    getFeedProposalData: (id: string): Promise<AxiosResponse<any>> =>
        //axiosInstance.get<IFeedProposalDataResponse>(`feed/${id}`),
        Promise.resolve({
          data: feedMock,
          status: 200,
          statusText: "OK",
          headers: {},
          config: {},
          request: {},
        }),
};
